var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocpy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 41,
    viewBox: "0 0 105 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "docpy",
    transform: "translate(0 33)",
    fill: "#ff6036",
    fontSize: 35,
    fontFamily: "ArialRoundedMTBold, Arial Rounded MT"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "docpy"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocpy);
export default __webpack_public_path__ + "static/media/docpy.840c66a6b9a0b7dab0c349fde80be683.svg";
export { ForwardRef as ReactComponent };